import React from "react";
import { Card, Row, Col, Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import { helpTopics } from "../../data/helpContent";
import { FaArrowRight } from "react-icons/fa";

function HelpHome({ searchQuery, user }) {
  // Filter topics based on search query
  const filteredTopics = searchQuery
    ? helpTopics.filter(
        (topic) =>
          topic.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
          topic.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
          topic.keywords.some((keyword) =>
            keyword.toLowerCase().includes(searchQuery.toLowerCase())
          )
      )
    : helpTopics;

  // Filter out admin topics for non-admin users
  const visibleTopics = filteredTopics.filter(
    (topic) => !topic.adminOnly || user?.isAdmin || user?.isSuperUser
  );

  if (searchQuery && visibleTopics.length === 0) {
    return (
      <div className="text-center py-5">
        <h4>No results found</h4>
        <p className="text-muted">
          Try searching with different keywords or browse topics from the sidebar.
        </p>
      </div>
    );
  }

  return (
    <div>
      {searchQuery ? (
        <>
          <h4 className="mb-4">Search Results ({visibleTopics.length})</h4>
          <Row>
            {visibleTopics.map((topic) => (
              <Col md={6} key={topic.id} className="mb-3">
                <Card className="h-100 shadow-sm">
                  <Card.Body>
                    <Card.Title className="d-flex justify-content-between align-items-start">
                      <span>{topic.title}</span>
                      {topic.adminOnly && (
                        <Badge bg="warning" text="dark">
                          Admin
                        </Badge>
                      )}
                    </Card.Title>
                    <Card.Text className="text-muted">{topic.description}</Card.Text>
                    <Link
                      to={`/help/${topic.id}`}
                      className="btn btn-outline-primary btn-sm"
                    >
                      Read More <FaArrowRight className="ms-2" />
                    </Link>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </>
      ) : (
        <>
          <h3 className="mb-4">Welcome to the Help Center</h3>
          <p className="lead mb-4">
            Find guides and tutorials to help you get the most out of the Customer Portal.
          </p>

          <Row className="mb-4">
            <Col md={12}>
              <Card className="bg-primary text-white mb-3">
                <Card.Body>
                  <h5>Quick Start</h5>
                  <p className="mb-3">
                    New to the portal? Start here to learn the basics.
                  </p>
                  <Link to="/help/getting-started" className="btn btn-light btn-sm">
                    Get Started <FaArrowRight className="ms-2" />
                  </Link>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <h5 className="mb-3">Browse by Category</h5>
          <Row>
            {visibleTopics.slice(0, 6).map((topic) => (
              <Col md={4} key={topic.id} className="mb-3">
                <Card className="h-100 shadow-sm">
                  <Card.Body>
                    <Card.Title className="d-flex justify-content-between align-items-start">
                      <span style={{ fontSize: "1rem" }}>{topic.title}</span>
                      {topic.adminOnly && (
                        <Badge bg="warning" text="dark" style={{ fontSize: "0.7rem" }}>
                          Admin
                        </Badge>
                      )}
                    </Card.Title>
                    <Card.Text className="text-muted small">
                      {topic.description}
                    </Card.Text>
                    <Link
                      to={`/help/${topic.id}`}
                      className="btn btn-outline-primary btn-sm"
                    >
                      Read More
                    </Link>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </>
      )}
    </div>
  );
}

export default HelpHome;
